import apiClient from '../api.js';
import { conToken } from '../autorizacion.js';

// Capa de servicios de los factores de crédito por sede, carrera y plan de
// estudios (HU-01). Backend: `UNICEN/modules/economico`.
// Contrato completo: UNICEN/modules/economico/docs/factores-credito.openapi.yaml
//
// Todas las rutas exigen el token de la sesión (quién carga sale de ahí, nunca
// del body). Respuestas: `{ data }`. Errores: `{ mensaje, campo?, rechazadas? }`
// (leer con `errorDeApi` de ../errores.js). Fechas 'AAAA-MM-DD'; factores y
// créditos como números.
//
//   GET  /economico/factores-credito?id_sede&incluir_inactivos&solo_sin_vigente
//        -> [{ combinacion, vigente: Carga|null, programados: [Carga] }]
//        `vigente: null` = hoy no se pueden calcular créditos de ese plan.
//
//   GET  /economico/factores-credito/:id_sede/:id_carrera/:id_plan_estudio
//        -> { combinacion, hoy, fecha_minima_inicio, cargas: [Carga] }
//
//   POST /economico/factores-credito/cargas
//        body { combinaciones: [{ id_sede, id_carrera, id_plan_estudio }],
//               factor_teorico, factor_practico, fecha_inicio, simular }
//        200 simulación (o nada que guardar) | 201 guardado
//        -> { simulacion, lote, resumen: { total, registradas, sin_cambios,
//             rechazadas }, resultados: [{ combinacion, resultado:
//             'REGISTRADA'|'SIN_CAMBIOS'|'RECHAZADA', registrada, cerrada,
//             reemplazadas, impacto, error }] }
//        `impacto` (solo al simular): { referencia, materias, cambian, en_cero,
//             detalle: [{ materia, cod_materia, horas_teoria, horas_practica,
//             creditos_actuales, creditos_nuevos }] }
//        409 al confirmar con rechazadas (no se guarda nada), 404 si una
//        combinación no existe, 400 con `campo` si un dato es inválido.
//
//   Carga: { id_factor_credito, id_lote, factor_teorico, factor_practico,
//            fecha_inicio, fecha_fin, estado: 'VIGENTE'|'PROGRAMADO'|
//            'FINALIZADO'|'REEMPLAZADO', id_reemplazado_por, id_usuario,
//            usuario, registrado_en }

const resource = '/economico/factores-credito';

const useFactoresCreditoApi = {
  listar({ id_sede, incluir_inactivos = false, solo_sin_vigente = false } = {}) {
    return apiClient.get(resource, conToken({ params: { id_sede, incluir_inactivos, solo_sin_vigente } }));
  },

  historial({ id_sede, id_carrera, id_plan_estudio }) {
    return apiClient.get(`${resource}/${id_sede}/${id_carrera}/${id_plan_estudio}`, conToken());
  },

  cargar({ combinaciones, factor_teorico, factor_practico, fecha_inicio, simular }) {
    return apiClient.post(
      `${resource}/cargas`,
      { combinaciones, factor_teorico, factor_practico, fecha_inicio, simular },
      conToken()
    );
  },
};

export default useFactoresCreditoApi;
